import { render, staticRenderFns } from "./FormLaporan.vue?vue&type=template&id=01d4e096&"
import script from "./FormLaporan.vue?vue&type=script&lang=js&"
export * from "./FormLaporan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports